<template lang="pug">
  div
    RegistrationAgencyInfo(
      v-if="this.stateMachine === 'agency'"
      @nextState="nextState()"
      @prevState="prevState($event)")
    RegistrationAgencySelect(
      v-if="this.stateMachine === 'agencySelect'"
      @nextState="nextState()"
      @prevState="prevState($event)"
      @cancel="cancel")
    RegistrationPersonalInfo(
      v-if="this.stateMachine === 'personal'"
      @nextState="nextState()"
      @prevState="prevState($event)"
      @cancel="cancel")
    RegistrationReviewInfo(
      v-if="stateMachine === 'review'"
      @nextState="nextState()"
      @prevState="prevState($event)"
      @cancel="cancel")
    RegistrationPending(
      v-if="stateMachine === 'pending'"
      @nextState="nextState()"
      @prevState="prevState($event)")
</template>

<script>
import RegistrationAgencyInfo from '../components/RegistrationAgencyInfo'
import RegistrationAgencySelect from '../components/RegistrationAgencySelect'
import RegistrationPersonalInfo from '../components/RegistrationPersonalInfo'
import RegistrationReviewInfo from '../components/RegistrationReviewInfo'
import RegistrationPending from '../components/RegistrationPending'
import { clearForm } from '@/lib/formstore'

const replScrollIntoView = require('scroll-into-view')

export default {
  name: 'Registration',
  data: function() {
    return {
      stateMachine: 'agency',
      registration: '',
    }
  },
  methods: {
    nextState() {
      switch (this.stateMachine) {
        case 'agency':
          this.stateMachine = 'agencySelect'
          break
        case 'agencySelect':
          this.stateMachine = 'personal'
          break
        case 'personal':
          this.stateMachine = 'review'
          break
        case 'review':
          this.stateMachine = 'pending'
          break
      }
      scrollTo(0, 0)
    },
    prevState(anchor) {
      switch (this.stateMachine) {
        case 'personal':
          this.stateMachine = 'agency'
          break
        case 'review':
          this.stateMachine = 'personal'
          this.$nextTick(() => {
            if (!anchor) return
            let elem = document.getElementById(anchor)
            replScrollIntoView(elem, { time: 1, align: { top: 0, left: 0 } })
          })
          break
      }
    },
    cancel() {
      this.$router.push({ name: 'login' })
    },
  },
  beforeRouteLeave(_to, _from, next) {
    clearForm('registration')
    next()
  },
  components: {
    RegistrationAgencyInfo,
    RegistrationAgencySelect,
    RegistrationPersonalInfo,
    RegistrationReviewInfo,
    RegistrationPending,
  },
}
</script>

<style lang="scss">
.gone {
  display: none;
}
</style>
